import { Fragment } from "react";
import { Route, Navigate } from "react-router-dom";

import * as C from "./lazyComponents";

const Private = ({ Component }) => <Component />;

export const AppRoutes = ({ user }) => (
  <Fragment>
    <Route
      path={`${process.env.PUBLIC_URL}/`}
      element={user ? <C.App /> : <Navigate to={`${process.env.PUBLIC_URL}/home`} />}
    >
      <Route index element={<C.Dashboard />} />

      <Route path={`${process.env.PUBLIC_URL}/dashboard`} element={<C.Dashboard />} />
      <Route path={`${process.env.PUBLIC_URL}/widgets`} element={<C.Widgets />} />

      <Route>
        {/* supreme court route links */}
        <Route
          path={`${process.env.PUBLIC_URL}/assign-module-to-role`}
          element={<C.AssignModuleToRole />}
        />
        <Route path={`${process.env.PUBLIC_URL}/submodule-list`} element={<C.CreateSubmodule />} />
        <Route path={`${process.env.PUBLIC_URL}/role`} element={<C.CreateRole />} />
        <Route path={`${process.env.PUBLIC_URL}/users-and-role`} element={<C.AssignUserToRole />} />
        <Route path={`${process.env.PUBLIC_URL}/users`} element={<C.AllUsers />} />
        <Route path={`${process.env.PUBLIC_URL}/create-user`} element={<C.CreateUser />} />
        <Route path={`${process.env.PUBLIC_URL}/module-list`} element={<C.CreateModule />} />
        <Route path={`${process.env.PUBLIC_URL}/my-profile`} element={<C.MyProfile />} />
        <Route path={`${process.env.PUBLIC_URL}/title-list`} element={<C.CreateTitle />} />
        <Route path={`${process.env.PUBLIC_URL}/enrolled-list`} element={<C.GetEnrollement />} />
        <Route
          path={`${process.env.PUBLIC_URL}/enrolled-users/list`}
          element={<C.EnrolledUserList />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/initial-application`}
          element={<C.InitialApplication />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/application-confirmation`}
          element={<C.ApplicationConfirmation />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/application-confirmation/:id`}
          element={<C.SingleConfirmation />}
        />
        {/* verified applications by state */}
        <Route
          path={`${process.env.PUBLIC_URL}/verified-applications-by-state`}
          element={<C.VerifiedApplicationsByState />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/uploaded-recommended-applications-by-state`}
          element={<C.RecommendedApplicationsByState />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/verified-applications-by-state-for-cr`}
          element={<C.VerifiedApplicationsByStateCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/uploaded-recommended-applications-by-state-for-cr`}
          element={<C.RecommendedApplicationsByStateCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/verified-applications-by-state-for-dcr`}
          element={<C.VerifiedApplicationsByStateDCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/uploaded-recommended-applications-by-state-for-dcr`}
          element={<C.RecommendedApplicationsByStateDCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/verified-applications-by-state-for-cjn`}
          element={<C.VerifiedApplicationsByStateCJN />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/uploaded-recommended-applications-by-state-for-cjn`}
          element={<C.RecommendedApplicationsByStateCJN />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enquiry-letter-by-state/:id`}
          element={<C.EnquiryLetterByState />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/generate-recommendation-letter-by-state/:stateId/:batchNumber`}
          element={<C.RecommendationLetterByState />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enquiry-letter-by-state-dcr/:stateId/:batchNumber`}
          element={<C.EnquiryLetterByStateDCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/generate-recommendation-letter-by-state-dcr/:stateId/:batchNumber`}
          element={<C.RecommendationLetterByStateDCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enquiry-letter-by-state-cr/:id`}
          element={<C.EnquiryLetterByStateCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/generate-recommendation-letter-by-state-cr/:stateId/:batchNumber`}
          element={<C.RecommendationLetterByStateCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enquiry-letter-by-state-cjn/:stateId/:batchNumber`}
          element={<C.EnquiryLetterByStateCJN />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/generate-recommendation-letter-by-state-cjn/:stateId/:batchNumber`}
          element={<C.RecommendationLetterByStateCJN />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/application-status`}
          element={<C.ApplicationStatus />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/practicing-fee-verification-by-nba`}
          element={<C.VerifyPracticeFee />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/resend-failed-payment`}
          element={<C.ResendFailedPayment />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/practicing-fee-verified-by-nba`}
          element={<C.VerifiedPracticeFeePage />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enrolled-user/:id`}
          element={<C.GetSingleEnrollment />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enrolled-user/edit/:id`}
          element={<C.EditEnrollment />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/graduants-upload`}
          element={<C.GraduantsUpload />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/change-of-name-request`}
          element={<C.GetChangeOfName />}
        />
        <Route path={`${process.env.PUBLIC_URL}/change-of-name`} element={<C.ChangeOfName />} />
        <Route
          path={`${process.env.PUBLIC_URL}/change-of-name/edit/:id`}
          element={<C.EditChangeOfName />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enrollment-confirmation/:id`}
          element={<C.EnrollmentConfirmation />}
        />
        <Route path={`${process.env.PUBLIC_URL}/payment/amount`} element={<C.Amount />} />
        <Route path={`${process.env.PUBLIC_URL}/to-enroll`} element={<C.ToEnroll />} />
        <Route
          path={`${process.env.PUBLIC_URL}/chief-registrars`}
          element={<C.ChiefRegistrars />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/create-chief-registrar`}
          element={<C.CreateChiefRegistrar />}
        />
        <Route path={`${process.env.PUBLIC_URL}/document-types`} element={<C.DocumentTypes />} />
        <Route path={`${process.env.PUBLIC_URL}/portal`} element={<C.Portal />} />
        <Route path={`${process.env.PUBLIC_URL}/dispatch-letter`} element={<C.DispatchLetter />} />
        <Route
          path={`${process.env.PUBLIC_URL}/create-chief-registrar/:id`}
          element={<C.CreateChiefRegistrar />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/approve-enrolled-lawyers`}
          element={<C.RegistrarApproveEnrolled />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/approval-list/:volume_no`}
          element={<C.RegistrarApprovalList />}
        />
        <Route path={`${process.env.PUBLIC_URL}/amount-list`} element={<C.CreateAmount />} />
        <Route
          path={`${process.env.PUBLIC_URL}/registered-users`}
          element={<C.GetRegisteredUsers />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/registered-users/dcr`}
          element={<C.GetRegisteredUsersDRC />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/registered-users/staff`}
          element={<C.GetRegisteredUsersStaff />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/all-approved-applicants`}
          element={<C.GetAllApprovedApplicants />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/signed-enquiry-letters`}
          element={<C.GetSignedEnquiryLetters />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/all-approved-recommendations`}
          element={<C.GetAllApprovedRecommendations />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/view-recommendation-letter`}
          element={<C.GetRecommendationLetter />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/view-oath-instrument`}
          element={<C.GetOathInstruments />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/approved-recommendations`}
          element={<C.GetApprovedRecommendations />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/view-by-batch/:stateId/:batchNumber`}
          element={<C.SingleRecommendation />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/view-single/:stateId/:batchNumber`}
          element={<C.SingleSignedLetter />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/acted-records-by-cj`}
          element={<C.GetActedRecordsByCj />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/acted-records-by-cjn`}
          element={<C.GetActedRecordsByCjn />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/signed-oath-instrument`}
          element={<C.GetSignedOathInstruments />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/awaiting-signature`}
          element={<C.GetAwaitingSignOathInstruments />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/sworn-in-application`}
          element={<C.GetSwornInApplications />}
        />
        <Route path={`${process.env.PUBLIC_URL}/cjn-letters`} element={<C.GetCjnLetters />} />
        <Route
          path={`${process.env.PUBLIC_URL}/approved-applications`}
          element={<C.GetApprovedApplications />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/complete-applications`}
          element={<C.GetCompletedApplications />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/completed-applications-ready-for-pickup`}
          element={<C.GetCompletedApplicants />}
        />
        <Route path={`${process.env.PUBLIC_URL}/oath-lists`} element={<C.GetOathLists />} />
        <Route path={`${process.env.PUBLIC_URL}/oath-list/:id`} element={<C.SingleOath />} />
        <Route path={`${process.env.PUBLIC_URL}/letters`} element={<C.GetLetters />} />
        <Route
          path={`${process.env.PUBLIC_URL}/state-responses-list`}
          element={<C.StateResponseList />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/judge-responses-list`}
          element={<C.JudgeResponseList />}
        />
        <Route path={`${process.env.PUBLIC_URL}/Oath-list`} element={<C.OathList />} />
        <Route path={`${process.env.PUBLIC_URL}/final-stage`} element={<C.FinalStage />} />
        <Route
          path={`${process.env.PUBLIC_URL}/oathevidence-list/:id`}
          element={<C.SingleOathList />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enquiry-letter/:id`}
          element={<C.EnquiryLetter />}
        />
        <Route path={`${process.env.PUBLIC_URL}/new-letter/:id`} element={<C.NewLetter />} />
        <Route path={`${process.env.PUBLIC_URL}/new-letterCJN/:id`} element={<C.NewLetterCJN />} />
        <Route path={`${process.env.PUBLIC_URL}/new-letter2/:id`} element={<C.NewLetter2 />} />
        <Route path={`${process.env.PUBLIC_URL}/oath`} element={<C.OathInstruments />} />
        <Route
          path={`${process.env.PUBLIC_URL}/certification-list`}
          element={<C.CertificationList />}
        />
        <Route path={`${process.env.PUBLIC_URL}/certification/:id`} element={<C.Certificate />} />
        <Route
          path={`${process.env.PUBLIC_URL}/awaiting-certification`}
          element={<C.AwaitingCertificationList />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/enquiry-letter-edit/:id`}
          element={<C.EditEnquiryLetter />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pending-letters`}
          element={<C.PendingLettersList />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/signed-letters`}
          element={<C.SignedLettersList />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/upload-recommendation-letter/:stateId/:batchNumber`}
          element={<C.UploadLetter />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/upload-oath-instrument/:id`}
          element={<C.UploadOathInstrument />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pending-letter/:id`}
          element={<C.SinglePendingLetter />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/profile/show-profile/:id`}
          element={<C.ViewProfile />}
        />
        <Route path={`${process.env.PUBLIC_URL}/comments/:id`} element={<C.AuditComments />} />
        <Route
          path={`${process.env.PUBLIC_URL}/profile/dcr-profile/:id`}
          element={<C.ViewProfileDCR />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/profile/profile/:id`}
          element={<C.ViewProfileStaff />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/profile/waitingStateResponse/:id`}
          element={<C.SingleStateResponse />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/profile/awaiting-recommendation-approval-by-state-cj/:id`}
          element={<C.SingleStateApproval />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/profile/awaiting-judge-recommendation/:id`}
          element={<C.SingleJudgeRecommendation />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/acted-records-by-cj/:id`}
          element={<C.ViewSingleActedRecordByCj />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/verified-applications/list`}
          element={<C.VerfiedApplications />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/assign-chief-judge`}
          element={<C.AssignChiefJudge />}
        />
        <Route path={`${process.env.PUBLIC_URL}/create-judge`} element={<C.CreateJudge />} />
        <Route path={`${process.env.PUBLIC_URL}/add-lga`} element={<C.AddLGA />} />
        <Route path={`${process.env.PUBLIC_URL}/change-name`} element={<C.ChangeName />} />
        <Route path={`${process.env.PUBLIC_URL}/payment-status-report`} element={<C.PaymentStatusReport />} />  
        {/* end supreme court route links */}
        <Route
          path={`${process.env.PUBLIC_URL}/components/cardsDesign`}
          element={<C.CardDesign />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/components/fullCalendar`}
          element={<C.FullCalendar />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/components/defaultChat`}
          element={<C.DefaultChat />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/components/notifications`}
          element={<C.Notifications />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/components/sweetAlerts`}
          element={<C.SweetAlerts />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/components/rangeSlider`}
          element={<C.RangeSlider />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/components/contentScrollBar`}
          element={<C.ContentScrollBar />}
        />
        <Route path={`${process.env.PUBLIC_URL}/components/loader`} element={<C.Loader />} />
        <Route path={`${process.env.PUBLIC_URL}/components/counters`} element={<C.Counters />} />
        <Route path={`${process.env.PUBLIC_URL}/components/rating`} element={<C.Rating />} />
        <Route path={`${process.env.PUBLIC_URL}/components/timeline`} element={<C.Timeline />} />
        <Route path={`${process.env.PUBLIC_URL}/components/treeview`} element={<C.Treeview />} />
      </Route>
      <Route>
        <Route path={`${process.env.PUBLIC_URL}/elements/alerts`} element={<C.Alerts />} />
        <Route path={`${process.env.PUBLIC_URL}/elements/buttons`} element={<C.Buttons />} />
        <Route path={`${process.env.PUBLIC_URL}/elements/colors`} element={<C.Colors />} />
        <Route
          path={`${process.env.PUBLIC_URL}/elements/avatarSquares`}
          element={<C.AvatarSquares />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/elements/avatarRounded`}
          element={<C.AvatarRounded />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/elements/avatarRadius`}
          element={<C.AvatarRadius />}
        />
        <Route path={`${process.env.PUBLIC_URL}/elements/dropDowns`} element={<C.DropDowns />} />
        <Route path={`${process.env.PUBLIC_URL}/elements/list`} element={<C.List />} />
        <Route path={`${process.env.PUBLIC_URL}/elements/tags`} element={<C.Tags />} />
        <Route
          path={`${process.env.PUBLIC_URL}/elements/paginations`}
          element={<C.Paginations />}
        />
        <Route path={`${process.env.PUBLIC_URL}/elements/navigation`} element={<C.Navigation />} />
        <Route path={`${process.env.PUBLIC_URL}/elements/typography`} element={<C.Typography />} />
        <Route
          path={`${process.env.PUBLIC_URL}/elements/breadcrumbs`}
          element={<C.Breadcrumbs />}
        />
        <Route path={`${process.env.PUBLIC_URL}/elements/badges`} element={<C.Badges />} />
        <Route path={`${process.env.PUBLIC_URL}/elements/panels`} element={<C.Panels />} />
        <Route path={`${process.env.PUBLIC_URL}/elements/thumbnails`} element={<C.Thumbnails />} />
      </Route>
      <Route>
        <Route
          path={`${process.env.PUBLIC_URL}/advancedElements/mediaObject`}
          element={<C.Mediaobject />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/advancedElements/accordions`}
          element={<C.Accordions />}
        />
        <Route path={`${process.env.PUBLIC_URL}/advancedElements/tabs`} element={<C.Tabs />} />
        <Route path={`${process.env.PUBLIC_URL}/advancedElements/charts`} element={<C.Charts />} />
        <Route path={`${process.env.PUBLIC_URL}/advancedElements/modal`} element={<C.Modal />} />
        <Route
          path={`${process.env.PUBLIC_URL}/advancedElements/tooltipandPopover`}
          element={<C.TooltipandPopover />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/advancedElements/progress`}
          element={<C.Progress />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/advancedElements/carousels`}
          element={<C.Carousels />}
        />
        <Route path={`${process.env.PUBLIC_URL}/advancedElements/headers`} element={<C.Header />} />
        <Route path={`${process.env.PUBLIC_URL}/advancedElements/footers`} element={<C.Footer />} />
        <Route
          path={`${process.env.PUBLIC_URL}/advancedElements/userList`}
          element={<C.UserList />}
        />
        <Route path={`${process.env.PUBLIC_URL}/advancedElements/search`} element={<C.Search />} />
        <Route
          path={`${process.env.PUBLIC_URL}/advancedElements/cryptoCurrencies`}
          element={<C.Cryptocurrencies />}
        />
      </Route>
      <Route>
        <Route path={`${process.env.PUBLIC_URL}/charts/chartJs`} element={<C.ChartJs />} />
        <Route path={`${process.env.PUBLIC_URL}/charts/echarts`} element={<C.Echarts />} />
        <Route path={`${process.env.PUBLIC_URL}/charts/nvd3charts`} element={<C.Nvd3charts />} />
        <Route path={`${process.env.PUBLIC_URL}/charts/PieCharts`} element={<C.PieCharts />} />
      </Route>
      <Route>
        <Route
          path={`${process.env.PUBLIC_URL}/tables/defaultTables`}
          element={<C.DefaultTables />}
        />
        <Route path={`${process.env.PUBLIC_URL}/tables/dataTables`} element={<C.DataTables />} />
      </Route>
      <Route>
        <Route path={`${process.env.PUBLIC_URL}/form/formAdvanced`} element={<C.FormAdvanced />} />
        <Route
          path={`${process.env.PUBLIC_URL}/form/formEditor`}
          element={<Private Component={C.FormEditor} />}
        />
        <Route path={`${process.env.PUBLIC_URL}/form/formWizard`} element={<C.FormWizard />} />
        <Route
          path={`${process.env.PUBLIC_URL}/form/formValidation`}
          element={<C.FormValidation />}
        />
      </Route>
      <Route>
        <Route path={`${process.env.PUBLIC_URL}/icon/fontAwesome`} element={<C.FontAwesome />} />
        <Route
          path={`${process.env.PUBLIC_URL}/icon/materialDesignIcons`}
          element={<C.MaterialDesignIcons />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/icon/simpleLineIcons`}
          element={<C.SimpleLineIcons />}
        />
        <Route path={`${process.env.PUBLIC_URL}/icon/featherIcons`} element={<C.FeatherIcons />} />
        <Route path={`${process.env.PUBLIC_URL}/icon/ionicIcons`} element={<C.IonicIcons />} />
        <Route path={`${process.env.PUBLIC_URL}/icon/flagIcons`} element={<C.FlagIcons />} />
        <Route
          path={`${process.env.PUBLIC_URL}/icon/pe7Icons`}
          element={<Private Component={C.Pe7Icons} />}
        />
        <Route path={`${process.env.PUBLIC_URL}/icon/themifyIcons`} element={<C.ThemifyIcons />} />
        <Route
          path={`${process.env.PUBLIC_URL}/icon/typiconsIcons`}
          element={<C.TypiconsIcons />}
        />
        <Route path={`${process.env.PUBLIC_URL}/icon/weatherIcons`} element={<C.WeatherIcons />} />
      </Route>
      <Route>
        <Route path={`${process.env.PUBLIC_URL}/pages/profile`} element={<C.Profile />} />
        <Route path={`${process.env.PUBLIC_URL}/pages/editProfile`} element={<C.EditProfile />} />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/mailInbox`}
          element={<Private Component={C.MailInbox} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/mailCompose`}
          element={<Private Component={C.MailCompose} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/gallery`}
          element={<Private Component={C.Gallery} />}
        />
        <Route path={`${process.env.PUBLIC_URL}/pages/aboutCompany`} element={<C.AboutCompany />} />
        <Route path={`${process.env.PUBLIC_URL}/pages/services`} element={<C.Services />} />
        <Route path={`${process.env.PUBLIC_URL}/pages/faqs`} element={<C.FAQS />} />
        <Route path={`${process.env.PUBLIC_URL}/pages/terms`} element={<C.Terms />} />
        <Route path={`${process.env.PUBLIC_URL}/pages/invoice`} element={<C.Invoice />} />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/pricingTables`}
          element={<C.PricingTables />}
        />
        <Route path={`${process.env.PUBLIC_URL}/pages/Blog/blog`} element={<C.Blog />} />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/Blog/blogDetails`}
          element={<C.BlogDetails />}
        />
        <Route path={`${process.env.PUBLIC_URL}/pages/Blog/blogPost`} element={<C.BlogPost />} />
        <Route path={`${process.env.PUBLIC_URL}/pages/empty`} element={<C.Empty />} />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/maps/leafletMaps`}
          element={<Private Component={C.LeafletMaps} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/maps/vectorMaps`}
          element={<Private Component={C.VectorMaps} />}
        />
        <Route path={`${process.env.PUBLIC_URL}/pages/e-commerce/shop`} element={<C.Shop />} />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/e-commerce/productDetails`}
          element={<C.ProductDetails />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/e-commerce/shoppingCart`}
          element={<C.ShoppingCarts />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/e-commerce/wishlist`}
          element={<C.Wishlist />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/e-commerce/checkout`}
          element={<Private Component={C.Checkout} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/FileManager/FileAttachments/FileAttachments`}
          element={<Private Component={C.FileAttachments} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/FileManager/FileDetails/FileDetails`}
          element={<Private Component={C.FileDetails} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/FileManagerFileManager/FileManager`}
          element={<C.FileManager />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pages/FileManager/FileManagerList/FileManagerList`}
          element={<C.FileManagerList />}
        />
      </Route>
    </Route>
  </Fragment>
);
